import { NAME } from './modules.constant';

export const selectModulesState = (state) => state[NAME];
